import React, { useCallback, useEffect, useState } from "react";
//hooks
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { useStations } from "hooks/useStations";
import { useTimer } from "hooks/useTimer";
// helpers
import { strings } from "../../helpers/multiConsts";
import { unitTypesOptions } from "views/Map/MapPageConfig";
// styles
import { FiltersContainer, Label } from "./styles";
// components
import MultiSelect from "react-multi-select-component";
// actions creators
import { setSelectedTypes, getStations } from "redux/ducks/mapPage";
import { convertToMapById } from "helpers/convertToMap";
import { useMemo } from "react";
// actions
import { getCompaniesV2 } from "redux/actions/companies/companiesAction_V2";
import { getTagsV2 } from "redux/actions/tags/getTagsAction";
import { getBrandsV2 } from "redux/actions/brands/brandsAction_V2";
import { getTanks } from "redux/actions/tanks/tanksAction";
import { getBrandSalesV2 } from "redux/actions/brands/brandsAction_V2";
import { getBrandNamesV2 } from "redux/actions/brands/brandsAction_V2";
import { getUnitsV2 } from "redux/actions/unitsSection/unitsAction";

const Filters = () => {
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.login);
  const { loadInfo } = useSelector((state) => state.unitsReducer);
  const { isLoading: isLoadingFilters } = useSelector(
    (state) => state.map,
    shallowEqual,
  );
  const { companies: companiesObject } = useSelector(
    (state) => state.companies,
  );
  const companies = convertToMapById(companiesObject);
  const types = useSelector((state) => state.map.types, shallowEqual);
  const [runTimer] = useTimer(2000);
  const companiesValues = useMemo(() => {
    return companies.map((company) => {
      return { value: company.id, label: company.name };
    });
  }, [companies]);
  const mapStations = useMemo(() => {
    return companies.reduce((list, company) => {
      list.set(company.id, company);
      return list;
    }, new Map());
  }, [companies]);
  const { stations, updateStations } = useStations(mapStations);
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [selectedStations, setSelectedStations] = useState([]);

  const stationsCall = (stations) => {
    const stationsId = stations.map((station) => station.value);
    dispatch(getStations(stationsId));
  };
  const handleSelectCompany = (event) => {
    setSelectedCompanies(event);
    event.length ? updateStations(event) : setSelectedStations([]);
  };
  const handleSelectStation = (event) => {
    setSelectedStations(event);
    if (event.length) {
      runTimer(stationsCall, [event]);
    }
  };
  const handleSelectTypes = useCallback(
    (event) => {
      dispatch(setSelectedTypes(event));
    },
    [dispatch],
  );
  const componentClass = "react-multi-select";

  const runAll = useCallback(() => {
    if (loadInfo) {
      dispatch(getCompaniesV2(token));
      dispatch(getTagsV2(token));
      dispatch(getBrandsV2());
      dispatch(getTanks(token));
      dispatch(getBrandNamesV2(token));
      dispatch(getBrandSalesV2(token));
      dispatch(getUnitsV2(token));
    }
  }, [token, loadInfo]);

  //Effects
  useEffect(() => {
    runAll();
  }, []);

  return (
    <FiltersContainer>
      <Label>Empresa:</Label>
      <MultiSelect
        options={companiesValues}
        value={selectedCompanies}
        overrideStrings={strings}
        isLoading={isLoadingFilters}
        className={`margin-btm-4 multi-info ${componentClass}`}
        onChange={handleSelectCompany}
        labelledBy={"Selecciona una o varias empresas..."}
      />
      <Label>Planta:</Label>
      <MultiSelect
        options={stations}
        className={`margin-btm-4 multi-info ${componentClass}`}
        overrideStrings={strings}
        isLoading={isLoadingFilters}
        value={selectedStations}
        onChange={handleSelectStation}
        labelledBy={"Selecciona una o varias plantas..."}
      />
      <Label>Tipo:</Label>
      <MultiSelect
        options={unitTypesOptions}
        className={`margin-btm-4 multi-info ${componentClass}`}
        overrideStrings={strings}
        isLoading={isLoadingFilters}
        value={types}
        onChange={handleSelectTypes}
        labelledBy={"Selecciona uno o varios tipos..."}
      />
    </FiltersContainer>
  );
};

export default Filters;
